<template>
    <div v-show="show" class="alert-wrap fixed-100">
        <div class="bg fixed-100"></div>
        <div class="alert-container center-middle">
            <div class="alert-content" v-html="content"></div>
            <div class="alert-ok-button" @click="$emit('OkEvent')">{{ okText }}</div>
            <div v-show="closeButton" class="alert-close-button" @click="$emit('CloseEvent')"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            default: '提示'
        },
        okText: {
            type: String,
            default: '确认'
        },
        closeButton: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false
        }
    }
}
</script>

<style scoped>
.alert-wrap {
    z-index: 9999;
}
.alert-wrap .bg {
    background: #333;
    position: absolute;
    z-index: 10;
    opacity: 0.9;
}
.alert-wrap .alert-container {
    background: #fff;
    position: absolute;
    left: 2rem;
    right: 2rem;
    z-index: 11;
    border: 1px solid #ccc;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    padding: 2.9rem 1rem 1rem 1rem;
    transform: scale(1, 1) translate(0, -50%);
    -webkit-transform: scale(1, 1) translate(0, -50%);
}
.alert-wrap .alert-container .alert-content {
    padding: 0 1.5rem;
    line-height: 2.2rem;
    font-size: 1.6rem;
    color: #000000;
    text-align: center;
}
.alert-wrap .alert-ok-button {
    margin-top: 2.5rem;
    height: 4.1rem;
    line-height: 4.1rem;
    text-align: center;
    font-size: 1.6rem;
    display: inline-block;
    width: 100%;
    background: #dc1e32;
    color: #fff;
}
.alert-wrap .alert-close-button {
    position: absolute;
    width: 1.6rem;
    height: 1.6rem;
    top: 1rem;
    right: 1rem;
    background: url('../../../assets/images/ico/ico-close.png') no-repeat;
    background-size: 100% 200%;
    background-position-y: 100%;
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/common/alert/alert.vue